<template>
    <div class="team-container">
        <div v-if="isShowTabs">
            <div class="nav-pill__wrapper mb-main">
                <div
                    class="nav-pill"
                    :class="{ selected: o.selected }"
                    v-for="(o, index) in tabs"
                    :key="index"
                    @click="selectTabs(o)"
                >
                    {{ o.name }}
                </div>
            </div>
        </div>

        <div
            v-if="isMobile && rankingTable.list[0]"
            class="standing-title standing-league-title py-16px"
        >
            <leagueIcon
                :icon="
                    rankingTable.list[0].leagueName
                        .replaceAll(' ', '-')
                        .toLowerCase() + `-${rankingTable.list[0].leagueId}`
                "
                className="mr-05rem icon-league league-standing-match__icon"
            >
                <img
                    :src="`${s3ImgUrl}/${rankingTable.list[0].logo}`"
                    class="league-standing-match__icon"
                />
            </leagueIcon>
            {{ rankingTable.list[0].leagueName }}
        </div>

        <div
            class="match-table match-table__header"
            v-if="!isWorldCup && !isSpecialEvent"
        >
            <div class="display-flex">
                <div class="match-table__index">#</div>
                <div class="match-table__club">
                    <div>{{ $t("TEAM") }}</div>
                </div>
            </div>
            <div class="match-table__score">
                <div v-if="type === 'form'">
                    {{ $t("LAST_6") }}
                </div>
                <template v-else>
                    <div class="match-table__score-box">MP</div>
                    <div class="match-table__score-box">W</div>
                    <div class="match-table__score-box">D</div>
                    <div class="match-table__score-box">L</div>
                    <div class="match-table__score-box">GD</div>
                    <div class="match-table__score-box bold">Pts</div>
                </template>
            </div>
        </div>
        <div v-show="!isLoading">
            <template v-if="!isWorldCup && !isSpecialEvent">
                <Navigation
                    :id="o.teamId"
                    :category="'team'"
                    :name="o.teamName"
                    class="match-table"
                    :class="[
                        `match-table-${o.promotionColor}`,
                        o.promotionColor === promotionRelegation
                            ? `match-table-${promotionRelegationColor}`
                            : '',
                        myTeam(o),
                        promotionLine(o, matchTableList, index),
                    ]"
                    v-for="(o, index) in matchTableList"
                    :key="index"
                >
                    <div class="display-flex-center">
                        <!-- :class="o.promotionColor" -->
                        <div class="match-table__index">{{ index + 1 }}</div>
                        <div class="match-table__club">
                            <div class="match-table__club-icon">
                                <Icon :logoUrl="o.logo"></Icon>
                            </div>
                            <div>{{ o.teamName }}</div>
                        </div>
                    </div>
                    <div class="match-table__score" v-if="type !== 'form'">
                        <div class="match-table__score-box">
                            {{ o.gamesPlayed === null ? "-" : o.gamesPlayed }}
                        </div>
                        <div class="match-table__score-box">
                            {{ o.gamesWon === null ? "-" : o.gamesWon }}
                        </div>
                        <div class="match-table__score-box">
                            {{ o.gamesDrawn === null ? "-" : o.gamesDrawn }}
                        </div>
                        <div class="match-table__score-box">
                            {{ o.gamesLost === null ? "-" : o.gamesLost }}
                        </div>
                        <!-- <div>{{ o.gamesScored === null ? "-" : o.gamesScored }}</div>
              <div>{{ o.gamesAgainst === null ? "-" : o.gamesAgainst }}</div> -->
                        <div class="match-table__score-box">
                            {{
                                o.goalsDifference === null
                                    ? "-"
                                    : o.goalsDifference
                            }}
                        </div>
                        <div class="match-table__score-box">
                            {{ o.points === null ? "-" : o.points }}
                        </div>
                    </div>
                    <div class="match-table__score" v-else>
                        <div
                            v-for="(resultName, index2) in [
                                'recentFirstResult',
                                'recentSecondResult',
                                'recentThirdResult',
                                'recentFourthResult',
                                'recentFifthResult',
                                'recentSixthResult',
                            ]"
                            class="match-table__score-box form-ball"
                        >
                            <div
                                :class="`match-table__standings__form-ball ball-${o[resultName]}`"
                            >
                                {{
                                    o[resultName] === "0"
                                        ? "W"
                                        : o[resultName] === "1"
                                        ? "D"
                                        : o[resultName] === "2"
                                        ? "L"
                                        : ""
                                }}
                            </div>
                        </div>
                    </div>
                </Navigation>

                <div class="no-data" v-show="isShowNoData">
                    {{ $t("NO_TABLE") }}
                </div>
            </template>
            <template v-else>
                <template v-if="showTableHeader">
                    <div class="display-flex-align-center">
                        <div
                            class="icon-league mr-05rem mb-05rem home-match__main-title-flag"
                        >
                            <img
                                v-if="standingsPageleagueId === 75"
                                :src="`${s3ImgUrl}/football/up/league/world_cup_2022_logo.png`"
                                class="img-contain w-100 h-100"
                            />
                            <img
                                v-else-if="standingsPageleagueId === 95"
                                :src="`${s3ImgUrl}/football/up/league/afc_2024_logo.png`"
                                class="img-contain w-100 h-100"
                            />
                            <img
                                v-else-if="standingsPageleagueId === 93"
                                :src="`${s3ImgUrl}/football/up/league/afcon_2024_logo.png`"
                                class="img-contain w-100 h-100"
                            />
                            <img
                                v-else-if="standingsPageleagueId === 67"
                                :src="`${s3ImgUrl}/football/up/league/uefa_euro_2024.png`"
                                class="img-contain w-100 h-100"
                            />
                            <img
                                v-else-if="standingsPageleagueId === 224"
                                :src="`${s3ImgUrl}/football/up/league/copa_america_2024.png`"
                                class="img-contain w-100 h-100"
                            />
                        </div>
                        <div
                            v-if="standingsPageleagueId === 75"
                            class="match-table__main-group-stage-title"
                        >
                            <span v-if="!isMobile">International | </span>FIFA
                            World Cup 2022 &trade;
                            <div class="home-match__country" v-if="isMobile">
                                International
                            </div>
                        </div>
                        <div
                            v-else-if="standingsPageleagueId === 95"
                            class="match-table__main-group-stage-title"
                        >
                            {{ $t("AFC_ASIAN_CUP_2023") }}
                        </div>
                        <div
                            v-else-if="standingsPageleagueId === 93"
                            class="match-table__main-group-stage-title"
                        >
                            {{ $t("AFRICA_CUP_OF_NATIONS_2023") }}
                        </div>
                        <div
                            v-else-if="standingsPageleagueId === 67"
                            class="match-table__main-group-stage-title"
                        >
                            {{ $t("UEFA_EURO_2024") }}
                        </div>
                        <div
                            v-else-if="standingsPageleagueId === 224"
                            class="match-table__main-group-stage-title"
                        >
                            {{ $t("COPA_AMERICA_2024") }}
                        </div>
                    </div>
                    <div class="match-table__main-group-stage-title">
                        {{ $t("GROUP_STAGE") }}
                    </div>
                </template>

                <!-- YIM: special for World Cup 2022 -->
                <template v-if="isMobile">
                    <div class="display-flex-align-center">
                        <div
                            class="icon-league mr-05rem mb-05rem home-match__main-title-flag"
                        >
                            <img
                                v-if="standingsPageleagueId === 75"
                                :src="`${s3ImgUrl}/football/up/league/world_cup_2022_logo.png`"
                                class="img-contain w-100 h-100"
                            />
                            <img
                                v-else-if="standingsPageleagueId === 95"
                                :src="`${s3ImgUrl}/football/up/league/afc_2024_logo.png`"
                                class="img-contain w-100 h-100"
                            />
                            <img
                                v-else-if="standingsPageleagueId === 93"
                                :src="`${s3ImgUrl}/football/up/league/afcon_2024_logo.png`"
                                class="img-contain w-100 h-100"
                            />
                            <img
                                v-else-if="standingsPageleagueId === 67"
                                :src="`${s3ImgUrl}/football/up/league/uefa_euro_2024.png`"
                                class="img-contain w-100 h-100"
                            />
                            <img
                                v-else-if="standingsPageleagueId === 224"
                                :src="`${s3ImgUrl}/football/up/league/copa_america_2024.png`"
                                class="img-contain w-100 h-100"
                            />
                        </div>
                        <!-- home-match__title-mobile -->
                        <div
                            v-if="standingsPageleagueId === 75"
                            class="match-table__main-group-stage-title"
                        >
                            FIFA World Cup 2022 &trade;
                            <div class="home-match__country">International</div>
                        </div>
                        <div
                            v-else-if="standingsPageleagueId === 95"
                            class="match-table__main-group-stage-title"
                        >
                            {{ $t("AFC_ASIAN_CUP_2023") }}
                        </div>
                        <div
                            v-else-if="standingsPageleagueId === 93"
                            class="match-table__main-group-stage-title"
                        >
                            {{ $t("AFRICA_CUP_OF_NATIONS_2023") }}
                        </div>
                        <div
                            v-else-if="standingsPageleagueId === 67"
                            class="display-flex flex-col mb-05rem"
                        >
                            <span
                                class="match-table__main-group-stage-title mb-0"
                                >{{ $t("UEFA_EURO_2024") }}</span
                            >
                            <span class="home-match__country" v-if="isMobile"
                                >Europe</span
                            >
                        </div>
                        <div
                            v-else-if="standingsPageleagueId === 224"
                            class="display-flex flex-col mb-05rem"
                        >
                            <span
                                class="match-table__main-group-stage-title mb-0"
                                >{{ $t("COPA_AMERICA_2024") }}</span
                            >
                            <span class="home-match__country" v-if="isMobile"
                                >Americas</span
                            >
                        </div>
                    </div>
                    <div class="match-table__main-group-stage-title">
                        {{ $t("GROUP_STAGE") }}
                    </div>
                </template>

                <div
                    class="match-table-wc__wrapper"
                    v-for="(group, index) in matchTableModified"
                    :key="index"
                >
                    <!-- tableName -->
                    <div class="match-table-wc__header">
                        {{ group.displayGroupName.split("-")[1] }}
                    </div>

                    <div class="match-table-wc__child-wrapper">
                        <div class="match-table match-table-row">
                            <div class="display-flex">
                                <!-- <div class="match-table__index">#</div> -->
                                <div class="match-table__club">
                                    <div>{{ $t("TEAM") }}</div>
                                </div>
                            </div>
                            <div class="match-table__score">
                                <div>MP</div>
                                <div>W</div>
                                <div>D</div>
                                <div>L</div>
                                <div>F</div>
                                <div>A</div>
                                <div>+-</div>
                                <div>P</div>
                            </div>
                        </div>

                        <div class="match-table-row-wrapper">
                            <Navigation
                                :id="o.teamId"
                                :category="'team'"
                                :name="o.teamName"
                                v-for="(o, index) in group.total"
                                :key="index"
                            >
                                <div class="match-table match-table-row">
                                    <div class="display-flex-center">
                                        <div
                                            class="match-table__index"
                                            :class="[
                                                isSpecialEvent &&
                                                (index === 0 || index === 1)
                                                    ? 'color-1'
                                                    : group.thirdQualified
                                                    ? 'color-2'
                                                    : 'color-sp-1',
                                                o.promotionColor,
                                            ]"
                                        >
                                            {{ o.qualified }}
                                        </div>
                                        <div class="match-table__club">
                                            <div class="match-table__club-icon">
                                                <Icon :logoUrl="o.logo"></Icon>
                                            </div>
                                            <div>{{ o.teamName }}</div>
                                        </div>
                                    </div>
                                    <div class="match-table__score">
                                        <div>
                                            {{
                                                o.gamesPlayed === null
                                                    ? "-"
                                                    : o.gamesPlayed
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                o.gamesWon === null
                                                    ? "-"
                                                    : o.gamesWon
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                o.gamesDrawn === null
                                                    ? "-"
                                                    : o.gamesDrawn
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                o.gamesLost === null
                                                    ? "-"
                                                    : o.gamesLost
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                o.gamesScored === null
                                                    ? "-"
                                                    : o.gamesScored
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                o.gamesAgainst === null
                                                    ? "-"
                                                    : o.gamesAgainst
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                o.goalsDifference === null
                                                    ? "-"
                                                    : o.goalsDifference
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                o.points === null
                                                    ? "-"
                                                    : o.points
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </Navigation>
                        </div>
                    </div>

                    <div class="no-data" v-show="isShowNoData">
                        {{ $t("NO_TABLE") }}
                    </div>

                    <!-- <div class="match-table__tips-wrapper" v-for="(o, index) in promotionList" :key="index">
                        <div class="match-table__tips" >
                            <div class="match-table__index" :class="o.color">#</div>
                            <div>{{o.value}}</div>
                        </div>
                    </div> -->
                </div>
                <div class="match-table__tips-wrapper" v-show="itIsCopa()">
                    <div class="match-table__tips">
                        <div class="match-table__index color-1">#</div>
                        <div>{{ $t("ADVANCE_TO_ROUND_OF_8") }}</div>
                    </div>
                </div>
                <div class="match-table__tips-wrapper" v-show="!itIsCopa()">
                    <div class="match-table__tips">
                        <div class="match-table__index color-1">#</div>
                        <div>{{ $t("ADVANCE_TO_ROUND_OF_16") }}</div>
                    </div>
                </div>
                <div class="match-table__tips-wrapper" v-show="!itIsCopa()">
                    <div class="match-table__tips">
                        <div class="match-table__index color-sp-1">#</div>
                        <div>
                            {{
                                $t("POSSIBLE_QUALIFICATION_FOR_THE_NEXT_STAGE")
                            }}
                        </div>
                    </div>
                </div>
                <div class="match-table__tips-wrapper">
                    <div class="match-table__tips">
                        <div class="match-table__index color-2">#</div>
                        <div>{{ $t("ADVANCE_TO_THE_KNOCKOUT_STAGE") }}</div>
                    </div>
                </div>
            </template>

            <div class="match-table__tips-wrapper-box">
                <div
                    class="match-table__tips-wrapper"
                    v-for="(o, index) in promotionList"
                    :key="index"
                >
                    <div class="match-table__tips">
                        <div
                            class="match-table__index"
                            :class="[
                                o.color,
                                o.color === promotionRelegation
                                    ? promotionRelegationColor
                                    : '',
                            ]"
                        ></div>
                        <div>{{ o.value }}</div>
                    </div>
                </div>
            </div>
        </div>
        <Loading v-show="isLoading"></Loading>
    </div>
</template>

<script>
import Loading from "@/components/indicator/Loading.vue";
import config from "@/js/config.js";
import leagueIcon from "@/components/Icon/LeagueIcon.vue";

import { mapGetters, mapActions } from "vuex";
export default {
    components: {
        Loading,
        leagueIcon,
    },
    props: {
        rankingTable: {
            type: Object,
        },
        matchTableListData: {
            type: Array,
        },
        matchTableTipsList: {
            type: Array,
        },
        isShowTabs: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: "total",
        },
        params: {
            type: String,
        },
        leagueId: {
            type: String,
        },
        isWorldCup: {
            type: Boolean,
            default: false,
        },
        isSpecialEvent: {
            type: Boolean,
            default: false,
        },
        showTableHeader: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            "teamInfo",
            "isMobile",
            "matchDetailScore",
            "currentLocale",
            "currentSportType",
        ]),
        isShowTabs() {},
        matchTableModified() {
            if (this.isWorldCup || this.isSpecialEvent) {
                this.matchTableList.forEach((group) => {
                    group.total.forEach((team, i) => {
                        if (this.isSpecialEvent && i <= 2 && !this.itIsCopa()) {
                            team.qualified = "#";
                        } else {
                            team.qualified = i == 0 || i == 1 ? "#" : "";
                        }
                    });
                });

                return this.matchTableList;
            }
        },
    },
    data() {
        return {
            s3ImgUrl: config.s3ImgUrl,
            isLoading: false,
            isShowNoData: false,
            tabs: [
                {
                    name: "All",
                    id: "",
                    selected: true,
                },
                {
                    name: "Home",
                    id: "1",
                    selected: false,
                },
                {
                    name: "Away",
                    id: "2",
                    selected: false,
                },
            ],
            matchTableList: [],
            standingsPageleagueId: null,
            promotionRelegation: "",
        };
    },

    watch: {
        //   params: {
        //     deep: true,
        //     handler(newVal, oldVal) {
        //       //pass param and get data from api here
        //       this.getSoccerLeagueRankingData(newVal);
        //     },
        //   },
        matchTableListData: {
            // direct pass data to render
            handler(newVal, oldVal) {
                this.matchTableList =
                    this.isWorldCup || this.isSpecialEvent
                        ? newVal
                        : newVal[this.type];

                for (var index in newVal["promotionList"]) {
                    if (
                        newVal["promotionList"][index].value.search(
                            "Relegation"
                        ) !== -1
                    ) {
                        this.promotionRelegation =
                            newVal["promotionList"][index].color;
                    }
                    if (newVal["promotionList"][index].value === "Relegation") {
                        this.promotionRelegationColor = "color-r";
                    }
                }

                this.promotionList = newVal["promotionList"];
            },
        },
        $route: {
            immediate: true,
            handler(to, from) {
                this.standingsPageleagueId = parseInt(
                    this.$route.params.leagueId
                );
            },
        },
    },

    mounted() {
        this.itIsCopa();
    },

    methods: {
        ...mapActions([
            "getSoccerLeagueRanking",
            "getMatchDetailScore",
            "getMatchDetailScoreAsync",
        ]),
        itIsCopa() {
            return [224].includes(this.$route.params.leagueId * 1);
        },

        async getSoccerTeamRanking(leagueIdList) {
            let params = {
                leagueIdList: leagueIdList,
            };
            this.isLoading = true;

            const result = await this.getSoccerTeamRanking(params);
            this.matchTableList = result.result;

            if (this.matchTableList.length === 0) {
                this.isShowNoData = true;
            } else {
                this.isShowNoData = false;
            }

            this.isLoading = false;
        },

        prevBtnMenuLeagueTableListClick() {
            this.getSoccerTeamRanking({
                leagueId: "",
            })
                .then((res) => {
                    this.matchTableList = res.result;
                })
                .catch((res) => {});
        },
        selectTabs(o) {
            this.tabs.forEach((x) => {
                x.selected = false;
            });
            o.selected = true;
            this.isLoading = true;
            // this.matchObj=[];
            setTimeout(() => {
                this.$nextTick(() => {
                    this.isLoading = false;
                });
            }, 800);
        },
        promotionLine(o, list, index) {
            let newColor = o.promotionColor;
            if (o.promotionColor === this.promotionRelegation) {
                newColor = this.promotionRelegationColor;
            }
            let lastPromotionColor =
                this.promotionList[this.promotionList.length - 1]?.color;
            let nextPromotion = list[index + 1] ? list[index + 1] : null;

            if (o.promotionColor !== lastPromotionColor) {
                let nextData = list[index + 1];
                if (nextData && nextData.promotionColor !== o.promotionColor) {
                    o["line"] = true;
                    if (nextPromotion && !nextPromotion.topline) {
                        return `bottom-line-${newColor}`;
                    }
                }
            } else {
                let prevData = list[index - 1];
                if (prevData && prevData.promotionColor !== o.promotionColor) {
                    o["topline"] = true;
                    return `top-line-${newColor}`;
                }
            }
            return "";
        },
        myTeam(o) {
            if (o.teamId === parseInt(this.teamInfo.id)) {
                return "my-team";
            }
        },
    },
};
</script>
<style scoped>
.team-container {
    background-color: var(--color-background-default-secondary);
}
.match-table__main-group-stage-title {
    font-size: 1.125rem;
    font-family: var(--weight-700);
    margin-bottom: 0.5rem;
}
.match-table__header-country__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.88rem;
    margin-bottom: 0.4rem;
}
.match-table__header {
    /* background-color: #212B30; */
    color: var(--color-text-default-secondary) !important;
    font-family: var(--weight-600);
    background-color: var(--color-background-default-tertiary);
}
.match-table-wc__header {
    background-color: #212b30;
    font-family: var(--weight-700);
    font-size: 0.875rem;
    padding: 0.875rem 0.75rem;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}
.match-table-wc__wrapper {
    margin-bottom: 1.5rem;
}
.match-table-wc__child-wrapper .match-table {
    border-bottom: 0;
    position: relative;
}
.match-table-wc__child-wrapper .match-table-row::after {
    content: "";
    width: calc(100% - 1.6rem);
    border-bottom: 1px solid #212b30;
    position: absolute;
    bottom: 0;
}
.match-table-wc__child-wrapper
    .match-table-row-wrapper
    a:last-of-type
    .match-table-row::after {
    border-bottom: none;
}
.match-table-wc__child-wrapper .match-table-row:hover::after {
    border-bottom: 1px solid var(--bg-hover);
}
.match-table {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--color-text-default-default);
    /* border-bottom:1px solid #212B30; */
    padding: 0.5rem 0.8rem;
    font-size: 14px;
    letter-spacing: 0.64px;
}

.match-table.selected {
    background-color: #212b30;
    color: white;
    font-family: var(--weight-700);
}
.match-table:hover {
    background-color: var(--color-background-default-default-hover);
}
.match-table__header:hover {
    background-color: var(--color-background-default-tertiary);
}
.match-table__index {
    margin-right: 0.3rem;
    width: 1.1rem;
}
.match-table-color-1,
.match-table-color-2,
.match-table-color-3,
.match-table-color-4,
.match-table-color-5,
.match-table-color-r,
.match-table-color-p {
    position: relative;
}
.match-table-color-1:after,
.match-table-color-2:after,
.match-table-color-3:after,
.match-table-color-4:after,
.match-table-color-5:after,
.match-table-color-p:after,
.match-table-color-r:after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 5%;
    width: 5px;
    height: 90%;
    border-radius: 0px 100px 100px 0px;
}
.match-table-color-1:after {
    background-color: var(--color-icon-primary-active);
}
.match-table-color-2:after {
    background-color: var(--secondary-400);
}
.match-table-color-3:after {
    background-color: var(--tertiary-600);
}
.match-table-color-4:after {
    background-color: var(--secondary-600);
}
.match-table-color-5:after {
    background-color: var(--warning-600);
}
.match-table-color-r:after {
    background-color: var(--color-icon-error-active);
}
.match-table-color-p:after {
    background-color: #ffc0cb;
}

.bottom-line-color-1 {
    border-bottom: 1px solid var(--color-icon-primary-active);
}
.bottom-line-color-2 {
    border-bottom: 1px solid var(--secondary-400);
}
.bottom-line-color-3 {
    border-bottom: 1px solid var(--tertiary-600);
}
.bottom-line-color-4 {
    border-bottom: 1px solid var(--secondary-600);
}
.bottom-line-color-5 {
    border-bottom: 1px solid var(--warning-600);
}
.bottom-line-color-r {
    border-bottom: 1px solid var(--color-icon-error-active);
}
.bottom-line-color-p {
    border-bottom: 1px solid #ffc0cb;
}
.top-line-color-1 {
    border-top: 1px solid var(--color-icon-primary-active);
}
.top-line-color-2 {
    border-top: 1px solid var(--secondary-400);
}
.top-line-color-3 {
    border-top: 1px solid var(--tertiary-600);
}
.top-line-color-4 {
    border-top: 1px solid var(--secondary-600);
}
.top-line-color-5 {
    border-top: 1px solid var(--warning-600);
}
.top-line-color-r {
    border-top: 1px solid var(--color-icon-error-active);
}
.top-line-color-p {
    border-top: 1px solid #ffc0cb;
}

.color-1,
.color-2,
.color-3,
.color-4,
.color-5,
.color-p,
.color-r {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    color: var(--color-text-default-secondary);
}
.color-1 {
    background-color: var(--color-icon-primary-active);
}
.color-2 {
    background-color: var(--secondary-400);
}
.color-3 {
    background-color: var(--tertiary-600);
}
.color-4 {
    background-color: var(--secondary-600);
}
.color-5 {
    background-color: var(--warning-600);
}
.color-p {
    background-color: #ffc0cb;
}
.color-r {
    background-color: var(--color-icon-error-active);
}
.color-sp-1 {
    color: #ed9c5a;
}
.match-table__club {
    display: flex;
    align-items: center;
    flex: 2;
    /* max-width: 8rem; */
}

.color-1,
.color-2,
.color-3,
.color-4,
.color-5,
.color-p,
.color-r {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    color: var(--color-text-default-secondary);
}
.color-1 {
    background-color: var(--color-icon-primary-active);
}
.color-2 {
    background-color: var(--secondary-400);
}
.color-3 {
    background-color: var(--tertiary-600);
}
.color-4 {
    background-color: var(--secondary-600);
}
.color-5 {
    background-color: var(--warning-600);
}
.color-p {
    background-color: #ffc0cb;
}
.color-r {
    background-color: var(--color-icon-error-active);
}
.color-sp-1 {
    color: #ed9c5a;
}
.match-table__club {
    display: flex;
    align-items: center;
    flex: 2;
    /* max-width: 8rem; */
    width: 100%;
}

.match-table__club-icon {
    margin-right: 12px;
}
.match-table__score {
    display: flex;
    width: 10rem;
    justify-content: space-between;
    text-align: center;
    color: var(--color-text-default-secondary);
}
.match-table__score > div {
    flex: 1;
    margin: 0 0.15rem;
    min-width: 26px;
}
.match-table__tips-wrapper {
    color: var(--color-text-default-secondary);
}

.match-table__tips-wrapper-box {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: var(--color-background-default-tertiary);
}
.match-table__tips {
    display: flex;
    flex-direction: row;
    margin: 0 0.8rem;
    padding: 0.5rem 0;
    font-size: 13px;
}
.match-table.my-team {
    font-family: var(--weight-600);
    background: var(--color-background-default-default);
}
.match-table__standings__form-ball {
    color: var(--white-1000);
    width: 25.6px !important;
    height: 25.6px !important;
    min-width: unset;
    border-radius: 50%;
    flex: unset !important;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
    position: relative;
    letter-spacing: 0.2px;
    font-family: var(--weight-600);
}
.form-ball:last-child {
    transform: translate3d(0, -1px, 0);
}
.match-table__score-box:last-child .match-table__standings__form-ball:after {
    width: 10px;
    height: 2px;
    border-radius: 2px;
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    display: block;
    content: "";
    background-color: red;
}

.match-table__standings__form-ball.ball-0,
.match-table__score-box:last-child
    .match-table__standings__form-ball.ball-0:after {
    background-color: var(--success-500);
}
.match-table__standings__form-ball.ball-1,
.match-table__score-box:last-child
    .match-table__standings__form-ball.ball-1:after {
    background-color: var(--gray-500);
}
.match-table__standings__form-ball.ball-2,
.match-table__score-box:last-child
    .match-table__standings__form-ball.ball-2:after {
    background-color: var(--error-500);
}
.match-table__score-box:last-child
    .match-table__standings__form-ball.ball-3:after {
    display: none;
}
.match-table__score {
    width: unset;
}
.match-table__score-box {
    /* width: 24px; */
    margin: 0 6px !important;
    flex: 0 !important;
    font-weight: normal;
}
.match-table__score-box:last-child {
    font-family: var(--weight-700);
}
.bold {
    font-family: var(--weight-700);
}
@media(max-width: 768px) {
    /* for test */
    .match-table__main-group-stage-title {
        font-size: 0.875rem;
    }

    .team-container {
        border-radius: 8px;
        padding-bottom: 2rem;
        margin: 16px 8px 48px;
    }
    .match-table__score-box {
        margin: 0 2px !important;
        width: 20px;
    }
    .match-table__header .match-table__score-box {
        font-weight: bold !important;
    }
    .match-table__header {
        background-color: transparent !important;
        padding: 15px 0.8rem;
    }
    .match-table__score > div {
        min-width: 20px;
    }
    .match-table__standings__form-ball {
        width: 20px !important;
        height: 20px !important;
    }
    .match-table {
        font-size: 13px;
    }
    .standing-league-title {
        padding: 8px 0 0 8px;
        font-size: 13px;
        font-family: var(--weight-600);
        display: flex;
        align-items: center;
    }
}
</style>

<style>
.league-standing-match__icon {
    width: 32px;
    height: 32px;
    margin-right: 8px;
}
</style>
